import { render, staticRenderFns } from "./NetsPage.vue?vue&type=template&id=2ae0e81d&scoped=true&"
import script from "./NetsPage.vue?vue&type=script&lang=js&"
export * from "./NetsPage.vue?vue&type=script&lang=js&"
import style0 from "./NetsPage.vue?vue&type=style&index=0&id=2ae0e81d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae0e81d",
  null
  
)

export default component.exports